import React, { useEffect, useState } from "react";
import { BiExport, BiImport } from "react-icons/bi";
import { toast } from "react-toastify";
import Select from "react-select";
import Loader from "../../../Components/Loader";
import CourierCountryServices from "../../../Services/CourierCountryServices";
import { vendorService } from "../../../Services/vendorService";

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;

const serviceOption = [
  { value: "EXPORT", label: "EXPORT" },
  { value: "IMPORT", label: "IMPORT" },
];

const ProviderOption = [
  { value: "Fedex", label: "Fedex" },
  { value: "Ups", label: "Ups" },
];

export const CourierFreightRateList = () => {
  const [loader, setLoader] = useState(true);
  const [errprovider, SetErrprovider] = useState();
  const [errservice, SetErrservice] = useState();

  const [providerType, setProviderType] = useState({
    value: "",
    label: "",
  });
  const [serviceType, setServiceType] = useState({
    value: "",
    label: "",
  });

  const [courierOptionlist, setCourierOptionlist] = useState();
  const [courierList, setCourierList] = useState();

  useEffect(() => {
    getItemList();
  }, []);

  const getVendorList = () => {
    vendorService.getVendor().then((res) => {
      if (res.status === true) {
        let arryVendor = [];
        res.data.map((val) => {
          if (val.vendor_type === "Courier")
            arryVendor.push({ value: val._id, label: val.vendor_name });
        });
        setCourierOptionlist(arryVendor);
      }
    });
  };

  useEffect(() => {
    getVendorList();

    const initialService = serviceOption.filter(
      (res) => res.value === "EXPORT"
    )[0];
    setServiceType({
      value: initialService.value,
      label: initialService.label,
    });

    const initialProvider = ProviderOption.filter(
      (res) => res.value === "Fedex"
    )[0];
    setProviderType({
      value: initialProvider.value,
      label: initialProvider.label,
    });
  }, []);

  const onSelectprovider = (e) => {
    setProviderType(e);
    getItemList(serviceType.value, e.label);
  };

  const onSelecttype = (e) => {
    setServiceType(e);
    getItemList(e.label, providerType.label);
  };

  const getItemList = (type, provider) => {
    let param = {
      service_type: type ? type.toUpperCase() : "EXPORT",
      service_provider: provider ? provider : "Fedex",
    };

    CourierCountryServices.getCouriercountryserviceprices(param).then((res) => {
      if (res.status) {
        setLoader(false);
        let arr =res.data;
        arr.sort(function(a,b){
          return a.kgs - b.kgs;
          }
      );
        setCourierList(res.data);
      } else {
        setLoader(false);
      }
    });
  };

  const onClickExport = () => {
    setLoader(true)
    var errorcount = 0;

    if (providerType.value === undefined) {
      SetErrprovider("*required.");
      errorcount++;
    }

    if (serviceType.value === undefined) {
      SetErrservice("*required.");
      errorcount++;
    }

    if (!courierList) {
      toast.error("No data found !");
      errorcount++;
    }

    let param = {
      service_type: serviceType.value ? serviceType.value : "EXPORT",
      service_provider: providerType.label
        ? providerType.label
        : "Fedex",
    };

    if (errorcount === 0) {
      CourierCountryServices.exportCouriercountryservice(param).then((res) => {
        if (res.status) {
          window.location.href = REACT_APP_API_BASEURL + "/" + res.data;
          toast.success("file download successfully");
          setLoader(false)
        } else {
          toast.error(res.message);
          setLoader(false)
        }
      });
    }
  };

  const onClickImport = (e) => {
    setLoader(true);
    var Errcount = 0;

    if (providerType.value === undefined) {
      SetErrprovider("*required.");
      Errcount++;
    }

    if (serviceType.value === undefined) {
      SetErrservice("*required.");
      Errcount++;
    }

    const formData = new FormData();
    formData.append("csv_file", e.target.files[0]);
    formData.append("service_type", serviceType.value);
    formData.append("service_provider", providerType.label.toUpperCase());

    if (Errcount === 0) {
      CourierCountryServices.importCouriercountryservice(formData).then(
        (res) => {
          if (res.status) {
            setLoader(false);
            getItemList();
            toast.success("file upload successfully");
          } else {
            toast.error(res.message);
            setLoader(false);
          }
        }
      );
    }
  };


  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="d-flex justify-content-between mb-3">
                <div className="me-3">
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        width: "200px",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    placeholder="Search with service..."
                    value={providerType}
                    onChange={(e) => onSelectprovider(e)}
                    options={courierOptionlist}
                  />
                  {!providerType.value && (
                    <div className="text-danger">{errprovider}</div>
                  )}
                </div>
                <div className="me-3">
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        width: "200px",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    placeholder="Search with type..."
                    value={serviceType}
                    onChange={(e) => onSelecttype(e)}
                    options={serviceOption}
                  />
                  {!serviceType.value && (
                    <div className="text-danger">{errservice}</div>
                  )}
                </div>
               
              </div>
              <div className="d-flex justify-content-end mb-3">
                <div>
                  <input
                    type="file"
                    id="upload"
                    accept=".csv"
                    hidden
                    onChange={(e) => onClickImport(e)}
                  />
                  <label
                    for="upload"
                    className="btn btn-danger waves-effect waves-light mx-1 my-0"
                  >
                    <BiExport />
                    Upload File
                  </label>
                </div>
                <div>
                  <button
                    className="btn btn-success waves-effect waves-light mx-1 my-0"
                    onClick={() => onClickExport()}
                  >
                    <BiImport />
                    Download File
                  </button>
                </div>
              </div>
            </div>
            <div className="table-responsive">

              {
                courierList && courierList.length > 0 &&
                <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="p-1 small">Zone</th>

                    {courierList && courierList.length > 0 &&
                      courierList[0].zone_price.map((val) => {
                        return <th className="p-1 small">{val.zone}</th>;
                      })}
                  </tr>
                  <tr>
                    <th className="p-1 small">Kgs</th>
                  </tr>
                </thead>
                <tbody>
                  {courierList &&
                    courierList.map((item, key) => {
                      return (
                        <tr key={key}>
                          <th className="p-1 small">{item.kgs}</th>
                          {item.zone_price.map((val) => {
                            return <th>{val.price}</th>;
                          })}
                        </tr>
                      );
                    })}
                  <tr>
                    
                  </tr>
                </tbody>
              </table>

              }


              
              {courierList && courierList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> No data available</h6>
                </div>
              )}
            </div>
          </div>
        </div>
        <Loader isShow={loader} />
      </div>
    </div>
  );
};
